import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

import Constants from '../constants';

import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhTWlocale from 'element-ui/lib/locale/lang/zh-TW';
import deLocale from 'element-ui/lib/locale/lang/de';
import esLocale from 'element-ui/lib/locale/lang/es';
import frLocale from 'element-ui/lib/locale/lang/fr';
import itLocale from 'element-ui/lib/locale/lang/it';
import jaLocale from 'element-ui/lib/locale/lang/ja';
import koLocale from 'element-ui/lib/locale/lang/ko';
import ptLocale from 'element-ui/lib/locale/lang/pt';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';

import localZHCNLocale from './_zh-CN';
import localENLocale from './_en.js';
import localZHTWLocale from './_zh-TW.js';
import localZHHKLocale from './_zh-HK.js';
import localDELocale from './_de.js';
import localESLocale from './_es.js';
import localFRLocale from './_fr.js';
import localITLocale from './_it.js';
import localJALocale from './_ja.js';
import localKOLocale from './_ko.js';
import localPTLocale from './_pt.js';
import localRULocale from './_ru.js';

import Utils from '../utils';

Vue.use(VueI18n);
// const softwareBrand = getQueryString('softwareBrand');
const locale = Constants.GLOBAL_KEYS.DEFAULT_LANG;
const i18n = new VueI18n({
  locale,
  fallbackLocale: locale,
  messages: {
    [Constants.GLOBAL_KEYS.LANG.ZH_CN.VALUE]: { ...zhLocale, ...localZHCNLocale },
    [Constants.GLOBAL_KEYS.LANG.EN.VALUE]: { ...enLocale, ...localENLocale },
    [Constants.GLOBAL_KEYS.LANG.ZH_HK.VALUE]: {...zhTWlocale, ...localZHHKLocale},
    [Constants.GLOBAL_KEYS.LANG.ZH_TW.VALUE]: {...zhTWlocale, ...localZHTWLocale},
    [Constants.GLOBAL_KEYS.LANG.DE.VALUE]: {...deLocale, ...localDELocale},
    [Constants.GLOBAL_KEYS.LANG.ES.VALUE]: {...esLocale, ...localESLocale},
    [Constants.GLOBAL_KEYS.LANG.FR.VALUE]: {...frLocale, ...localFRLocale},
    [Constants.GLOBAL_KEYS.LANG.IT.VALUE]: {...itLocale, ...localITLocale},
    [Constants.GLOBAL_KEYS.LANG.JA.VALUE]: {...jaLocale, ...localJALocale},
    [Constants.GLOBAL_KEYS.LANG.KO.VALUE]: {...koLocale, ...localKOLocale},
    [Constants.GLOBAL_KEYS.LANG.PT.VALUE]: {...ptLocale, ...localPTLocale},
    [Constants.GLOBAL_KEYS.LANG.RU.VALUE]: {...ruLocale, ...localRULocale}
  }
});

const channel = Utils.Params.get('channel');
if (channel === 'odm') {
  document.title = i18n.messages[locale].title.replace('MAXHUB', '');
} else {
  document.title = i18n.messages[locale].title;
}

export default i18n;

function setI18nLanguage (lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  document.title = i18n.messages[lang].title;
  if (channel === 'odm') {
    document.title = i18n.messages[lang].title.replace('MAXHUB', '');
  } else {
    document.title = i18n.messages[lang].title;
  }
  return lang;
}

// function getQueryString(name) {
//   let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
//   let r = window.location.search.substr(1).match(reg);
//   if (r != null) {
//     return decodeURIComponent(r[2]);
//   };
//   return null;
// }

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}



// WEBPACK FOOTER //
// ./src/i18n/index.js